import Ellipse from "@/assets/style/Ellipse.svg";
import EnterpriseContactForm from "@/components/contactForm/EnterpriseContactForm";
import SelectLicenseHeader from "@/components/header/SelectLicenseHeader";
import Toaster from "@/components/ui/toaster";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { useTranslation } from "react-i18next";

const EnterpriseForm = () => {
    const { t } = useTranslation();
    const { data: userProfile } = useGetUserProfile();

    return (
        <div className="text-text-main-title relative flex h-screen w-screen flex-col overflow-x-hidden">
            <SelectLicenseHeader user={userProfile!} />

            <img
                alt="Ellipse"
                className="absolute top-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
                src={Ellipse}
            />
            <img
                alt="Ellipse"
                className="absolute -right-32 bottom-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
                src={Ellipse}
            />

            <main className="relative flex flex-col items-center gap-6 py-6">
                <h1 className="text-center font-display text-5xl font-normal">
                    {t("enterpriseForm.title")}
                </h1>
                <p className="mt-4 max-w-2xl text-center text-text-body">
                    {t("enterpriseForm.description")}
                </p>
                <div className="mt-6 w-full max-w-2xl">
                    <EnterpriseContactForm />
                </div>
            </main>
            <Toaster />
        </div>
    );
};

export default EnterpriseForm;
